module.exports = __webpack_public_path__ + "static/media/sidebar_bg.f60226c2.jpg";